import React from 'react';
import { Popover, Offcanvas, Table } from 'react-bootstrap';
import { ReactSVGWrapper } from '../WrapperComponent';

const breedsTip = (
  <>
    <Offcanvas.Header closeButton>
      <Offcanvas.Title>
        <ReactSVGWrapper
          src='/images/icons/question.svg'
          className='d-inline-block me-2'
        />
        Breeds
      </Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body>
      <p>
        Please select your pet's breed from the list provided. If you cannot
        find your breed, please call us.
      </p>
      <p>
        Insurance is for companion pets. We do not insure guard/security dogs,
        working dogs, fighting/coursing dogs or working gun dogs. However, we do
        allow show dogs, search and rescue dogs, guide dogs, assistance dogs,
        customs/sniffer dogs and former racing dogs now rehomed.
      </p>
      <p>
        We only insure domesticated cats, we do not extend cover to wild cats
        and wild cat hybrids.
      </p>
    </Offcanvas.Body>
  </>
);
const petsBirthDate = (
  <>
    <Offcanvas.Header closeButton>
      <Offcanvas.Title>
        <ReactSVGWrapper
          src='/images/icons/question.svg'
          className='d-inline-block me-2'
        />
        Pet's Birth Date
      </Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body>
      <p>
        The minimum entry age for a puppy or kitten is 6 weeks. This is the
        generally accepted age for a puppy or kitten to be removed from the
        mother for adoption or purchase in Australia.
      </p>
      <p>
        The maximum entry age for a new policy is 8 years and 364 days. The
        maximum entry age is to protect against policies being written that
        would result in a poor customer experience due to a high number of
        pre-existing condition exclusions.
      </p>
      <p>
        There is no maximum renewal age and we will not deny renewal based on
        your pet's age if it validly joined Petsy Pet Insurance.
      </p>
    </Offcanvas.Body>
  </>
);
const policyStartDate = (
  <>
    <Offcanvas.Header closeButton>
      <Offcanvas.Title>
        <ReactSVGWrapper
          src='/images/icons/question.svg'
          className='d-inline-block me-2'
        />
        Policy Start Date
      </Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body>
      <p>
        Your Period of Insurance will start at 23:59 on the Policy Start Date.
      </p>
      <p>
        You may select a future start date for your pet, up to 30 days from
        today.
      </p>
      <p>
        If your pet is too young to be eligible for cover today we have proposed
        the first date your pet become eligible or come back when your pet is at
        least 2 weeks old.
      </p>
      <p>
        <strong>Future-Dated Policy Payments</strong>
      </p>
      <p>
        Please note your first payment will be charged on the day you purchase
        the policy, not the effective start date of the policy.
      </p>
      <p>
        To align your payment date with a future start date, complete the
        application on the day you'd like the payment to be charged.
      </p>
    </Offcanvas.Body>
  </>
);
const annualLimit = (
  <>
    <Offcanvas.Header closeButton>
      <Offcanvas.Title>
        <ReactSVGWrapper
          src='/images/icons/question.svg'
          className='d-inline-block me-2'
        />
        Annual Limit
      </Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body>
      <p>Our Policy provides cover up to the Annual Limit you select.</p>
      <p>
        The Annual Limit is the maximum amount We pay for all accepted claims in
        relation to a Period of Insurance.
      </p>
      <p>
        Please be careful when selecting your Annual Limit, you can request to
        reduce it at any time, but after your policy has started you will not be
        able to increase it.
      </p>
    </Offcanvas.Body>
  </>
);
const benefitPercentage = (
  <>
    <Offcanvas.Header closeButton>
      <Offcanvas.Title>
        <ReactSVGWrapper
          src='/images/icons/question.svg'
          className='d-inline-block me-2'
        />
        Benefit Percentage
      </Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body>
      <p>
        You choose how much of the Vet Costs we cover. The Benefit Percentage
        you pick is the proportion of Vet Costs that we cover in the event of a
        claim.
      </p>
      <p> Please see the following claim examples:</p>
      <Table striped bordered size='sm'>
        <thead>
          <tr>
            <th>Benefit Percentage</th>
            <th>80%</th>
            <th>90%</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Claims Cost</td>
            <td>$1,000</td>
            <td>$1,000</td>
          </tr>
          <tr>
            <td>We Pay</td>
            <td>$800</td>
            <td>$900</td>
          </tr>
          <tr>
            <td>You Pay</td>
            <td>$200</td>
            <td>$100</td>
          </tr>
        </tbody>
      </Table>
    </Offcanvas.Body>
  </>
);
const annualExcess = (
  <>
    <Offcanvas.Header closeButton>
      <Offcanvas.Title>
        <ReactSVGWrapper
          src='/images/icons/question.svg'
          className='d-inline-block me-2'
        />
        Annual Excess
      </Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body>
      <p>
        If You choose to add an Annual Excess to Your Policy this amount needs
        to be met before We begin to pay benefits for accepted claims, at Your
        chosen Benefit Percentage.
      </p>
      <p>Only accepted claims will be applied to Your Annual Excess.</p>
      <p>
        Your Annual Excess will reset at the start of each Period of Insurance.
      </p>
      <p>
        You can increase your Annual Excess at any time, and you can choose to
        reduce it when your policy renews at the end of your Period of
        Insurance.
      </p>
      <p>Please see the following example:</p>
      <Table striped bordered size='sm'>
        <thead>
          <tr>
            <th>Benefit Percentage:</th>
            <th colSpan={2} className='text-center'>
              80%
            </th>
          </tr>
        </thead>
        <thead>
          <tr>
            <th>Annual Excess:</th>
            <th colSpan={2} className='text-center'>
              $150
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td></td>
            <td colSpan={2} className='text-center'>
              During same Period of Insurance
            </td>
          </tr>
          <tr>
            <td></td>
            <td className='text-center'>First Claim</td>
            <td className='text-center'>Second Claim</td>
          </tr>
          <tr>
            <td>Claimed Vet Costs</td>
            <td className='text-center'>$200</td>
            <td className='text-center'>$200</td>
          </tr>
          <tr>
            <td>Less Annual Excess</td>
            <td className='text-center'>$150</td>
            <td className='text-center'>$0</td>
          </tr>
          <tr>
            <td>We Pay</td>
            <td className='text-center'>
              $40
              <br />
              <span style={{ fontSize: '0.7em' }}>(($200-$150)*80%)</span>
            </td>
            <td className='text-center'>
              $160
              <br />
              <span style={{ fontSize: '0.7em' }}>($200*80%)</span>
            </td>
          </tr>
          <tr>
            <td>You Pay</td>
            <td className='text-center'>$160</td>
            <td className='text-center'>$40</td>
          </tr>
        </tbody>
      </Table>
    </Offcanvas.Body>
  </>
);
const suburbAndPostcode = (
  <>
    <Offcanvas.Header closeButton>
      <Offcanvas.Title>
        <ReactSVGWrapper
          src='/images/icons/question.svg'
          className='d-inline-block me-2'
        />
        Where You Live
      </Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body>
      <p>
        We use your postcode and state information as inputs into our pricing
        algorithm. We also collect stamp duty in certain states which affects
        your final price.
      </p>
      <p>
        If you need to correct your state and postcode information you need to
        go back to step one so that we can update your quote.
      </p>
    </Offcanvas.Body>
  </>
);
const desexing = (
  <>
    <Offcanvas.Header closeButton>
      <Offcanvas.Title>
        <ReactSVGWrapper
          src='/images/icons/question.svg'
          className='d-inline-block me-2'
        />
        Desexing
      </Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body>
      <p>We do not cover the cost of spaying or neutering.</p>
      <p>
        We do, however, if it's not a Pre-existing Condition, cover additional
        Vet Costs for Treatment of complex cryptorchid (undescended testicles).
        If this is the case, We will reduce the Vet Costs by the amount the Vet
        would have charged for neutering when calculating the payable benefit.
      </p>
    </Offcanvas.Body>
  </>
);
const optionalExtras = (
  <>
    <Offcanvas.Header closeButton>
      <Offcanvas.Title>
        <ReactSVGWrapper
          src='/images/icons/question.svg'
          className='d-inline-block me-2'
        />
        Optional Extras
      </Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body>
      <p>
        Certain conditions and Treatments are excluded under the Policy as
        standard. You have the option to include Extras Benefits and extend
        cover for some conditions and treatments not otherwise covered under the
        Policy. Selecting Extras adds cover for:
      </p>
      <ul>
        <li>
          Vet Costs for Dental Illness (Note this does not include cover for
          general dental check-up and clean.)
        </li>
        <li>Vet Costs for Behavioural Conditions and</li>
        <li>
          Vet Costs for Specialised Therapies for Treatment of covered
          conditions and does not include routine, elective treaments or
          supplements.
        </li>
      </ul>
    </Offcanvas.Body>
  </>
);
const vetConsultationFees = (
  <>
    <Offcanvas.Header closeButton>
      <Offcanvas.Title>
        <ReactSVGWrapper
          src='/images/icons/question.svg'
          className='d-inline-block me-2'
        />
        Cover Vet Consultation Fees
      </Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body>
      <p>
        Vet consultation fees are what your vet charges when your pet needs to be seen by them, due to an illness or injury.
        This is additional to treatment costs, such as those relating to diagnostic tests, medication and surgery.
      </p>
      <p>
        At Petsy, you can choose to include or exclude vet consultation fees or “vet consults” in your policy.
      </p>
      <p>
        If you include vet consults:
      </p>
      <p>
        We'll help cover the vet consultation fees when your pet is sick or hurt (including after-hours and emergency visits).
      </p>
      <p>
        Note: This doesn't include vet consultation fees for routine and regular check-ups, vaccinations, desexing, or any other conditions or treatments that are not covered under your policy.
      </p>
      <p>
        If you exclude vet consults:
      </p>
      <p>
        You'll need to pay for the vet consultation fees yourself, even for emergencies. We'll still help cover eligible treatment costs, just not the vet consultation fees.
      </p>
      <p>
        Why some pet parents choose to exclude vet consults:
      </p>
      <ul>
        <li>They get free or discounted vet consultation fees through their vet or employer.</li>
        <li>They have a wellness plan that includes vet consultation fees.</li>
        <li>They receive pensioner discounts on vet consultation fees from their local vet.</li>
      </ul>
      <p>
        If you're unsure, many pet parents choose to include vet consults in their cover, especially for peace of mind in case of unexpected or after-hours emergencies. 
        If you'd like more information on vet consultation fees, please contact us on 1300 952 790.
      </p>
    </Offcanvas.Body>
  </>
);
const misrepresentation = (
  <>
    <Offcanvas.Header closeButton>
      <Offcanvas.Title>
        <ReactSVGWrapper
          src='/images/icons/question.svg'
          className='d-inline-block me-2'
        />
        Misrepresentation
      </Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body>
      <p>
        You must take reasonable care not to make a misrepresentation to Us.
        This responsibility applies until We issue You with a policy for the
        first time or agree to renew, extend, vary/change, or reinstate Your
        Policy.
      </p>
      <p>
        You must answer Our questions honestly, accurately and to the best of
        Your knowledge. A misrepresentation includes a statement that is false,
        partially false, or which does not fairly reflect the truth. It may not
        be a misrepresentation if You do not answer a question or if Your answer
        is obviously incomplete or irrelevant to the question asked. However,
        not answering a question may be a misrepresentation where you know, it
        is reasonable you should have known or you could have obtained the
        answer.
      </p>
      <p>
        The responsibility to take reasonable care not to make a
        misrepresentation applies to everyone who will be insured under the
        policy. If You are answering questions on behalf of anyone, We will
        treat Your answers or representations as theirs.
      </p>
      <p>
        Whether or not You will have taken reasonable care not to make a
        misrepresentation is to be determined having regard to all relevant
        circumstances, including the type of insurance, who it is intended to be
        sold to, whether You are represented by a broker, Your particular
        characteristics and circumstances We are aware of.
      </p>
      <p>
        If You do not meet the above Duty We may reject or not fully pay Your
        claim and/or cancel Your Policy. If the misrepresentation was deliberate
        or reckless, this is an act of fraud, and We may treat Your Policy as if
        it never existed.
      </p>
      <p>
        If Our information or questions are unclear, You can contact Us on 1300
        952 790 or visit www.petsy.com.au
      </p>
    </Offcanvas.Body>
  </>
);

const noSubLimits = (
  <>
    <Offcanvas.Header closeButton>
      <Offcanvas.Title>
        <ReactSVGWrapper
          src='/images/icons/question.svg'
          className='d-inline-block me-2'
        />
        What is a sublimit?
      </Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body>
      <p>
        Also known as a “condition limit” or “per incident limit”, a sub limit
        acts as a ceiling limiting claims made on a pet insurance policy per
        year (period of insurance), for treating certain conditions.
      </p>
      <p>
        With Petsy having no sub limits means that there will be no extra limits
        placed on any veterinary expenses, subject to benefit percentage, annual
        limit and annual excess.
      </p>
      <Offcanvas.Title>
        Explaining sub limits on specific treatments
        <p className='pt-3'>
          With most other pet insurance policies, certain sub limits are placed
          as monetary caps on specific treatments. If (for example) you chose a
          pet insurance policy with an annual benefit limit of $10,000 but the
          policy had a sub limit of $2,500 for cruciate ligament conditions, you
          will not be reimbursed more than $2,500 for your pet's cruciate
          ligament condition due to the sub limit clause, even though your
          annual benefit limit is $10,000.
        </p>
        <p>
          Unlike many other pet insurance products in the market, Petsy Pet
          Insurance proudly offers no sub limits.
        </p>
        <p>
          Once you've passed your Exclusion Period and as long as the condition
          you're claiming for is not pre-existing, there are no pay-out limits
          placed on specific injuries, illnesses or treatment costs. This means
          that you can claim up to the full annual benefit limit of your choice
          ($10,000 or $25,000) and this applies to all the inclusions under your
          policy, including (commonly) expensive treatments for accidental
          injuries and illnesses, which are frequently capped with most other
          pet insurance policies.
        </p>
        <p>
          Common examples of treatments with sub-limits include hip surgery,
          cruciate ligament surgery, overnight emergency stays and dental
          illness, if selected as an optional extra.
        </p>
        <p>
          It's important to understand that like most pet insurance policies,
          cover will start after the applicable Exclusion Period has elapsed.
          Any Injury, Illness, or Specified Condition that occurs during the
          applicable Exclusion Period will also be deemed to be a Pre-existing
          Condition.
        </p>
        <ul>
          <li>
            1 Day Exclusion Period for Accidental Injury (except Specified
            Conditions)
          </li>
          <li>
            14 days Exclusion Period for Illness (except Specified Conditions)
          </li>
          <li>
            14 days Exclusion Period for Dental Illness for pets under 1 year
            old (6 months if pet is 1 year or older)
          </li>
          <li>
            6 months Exclusion Period for Specified Conditions and Behavioural
            Conditions
          </li>
        </ul>
      </Offcanvas.Title>
    </Offcanvas.Body>
  </>
);

const step1MultiPetDiscountTip = (
  <>
    <Offcanvas.Header closeButton>
      <Offcanvas.Title>
        <ReactSVGWrapper
          src='/images/icons/question.svg'
          className='d-inline-block me-2'
        />
        Get 5% off for each additional pet
      </Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body>
      <Offcanvas.Title>
        More than one pet in your home?
        <p className='pt-3'>
          Receive a 5% lifetime discount for every additional pet you insure
          with us after the first. No extra steps needed, we'll apply it
          automatically. If you choose to use a promotion code or a Petsy
          Corporate Benefits discount instead, it'll replace the multi-pet
          discount.
        </p>
        <p>
          If you're looking to add a new pet to an existing policy, please
          contact us directly.
        </p>
      </Offcanvas.Title>
    </Offcanvas.Body>
  </>
);

const paymentFrequencyTip = (
  <>
    <Offcanvas.Header closeButton>
      <Offcanvas.Title>
        <ReactSVGWrapper
          src='/images/icons/question.svg'
          className='d-inline-block me-2'
        />
        How your premium is calculated:
      </Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body>
      <Offcanvas.Title>
        How your premium is calculated:
        <p className='pt-3'>
          <ul>
            <li>
              <strong>Monthly:</strong> Your annual premium is split into 12
              equal payments, billed monthly.
            </li>
            <li>
              <strong>Fortnightly:</strong> Your annual premium is divided by
              26.07 to spread the cost evenly every two weeks. We don't process
              fortnightly payments.
            </li>
          </ul>
        </p>
      </Offcanvas.Title>

      <Offcanvas.Title>
        Paying annually
        <p className='pt-3'>
          Want to pay for the full year upfront? Here's how:
        </p>
        <div>
          <ol>
            <li>Sign up and pay for your first month online</li>
            <li>
              Email us at hello@petsy.com.au to switch to an annual payment and
              we'll arrange the rest as a lump sum.
            </li>
          </ol>
        </div>
      </Offcanvas.Title>
      <Offcanvas.Title>
        How we display pricing:
        <p className='pt-3'>
          <ul>
            <li>Price breakdowns are based on monthly payments.</li>
            <li>
              If you have a discount, we show your total savings upfront for the
              first policy period.
            </li>
          </ul>
        </p>
      </Offcanvas.Title>
      <Offcanvas.Title>
        More than one pet in your home?
        <p className='pt-3'>
          Receive a 5% lifetime discount for every additional pet you insure
          with us after the first. No extra steps needed, we'll apply it
          automatically. If you choose to use a promotion code or a Petsy
          Corporate Benefits discount instead, it'll replace the multi-pet
          discount.
        </p>
        <p>
          If you're looking to add a new pet to an existing policy, please
          contact us directly.
        </p>
      </Offcanvas.Title>
    </Offcanvas.Body>
  </>
);

const specifiedConditionsTip = (
  <>
    <Offcanvas.Header closeButton>
      <Offcanvas.Title>
        <ReactSVGWrapper
          src='/images/icons/question.svg'
          className='d-inline-block me-2'
        />
        What are Specified Conditions?
      </Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body>
      <Offcanvas.Title>
        <p className='pt-3'>
          Petsy Pet Insurance has a 6 month exclusion period applicable to Specified Conditions.
        </p>
        <p>
          These includes cruciate ligament damage, intervertebral disc disease, hip dysplasia, patella luxation, elbow dysplasia, osteochondritis dissecans (OCD), cherry eye, entropion, ectropion, and lumps.
        </p>
        <p>
          Lumps means the protuberance or localised area of swelling or unusual growth that can occur anywhere on the body including tumours, warts, cysts, growths and abscesses.
        </p>
        <p>
          Lumps are not considered a Specified Condition if Your Pet was under one (1) year old on the First Date of Cover or when Your cover increased.
        </p>
      </Offcanvas.Title>
    </Offcanvas.Body>
  </>
);

export const tips = {
  breedsTip: breedsTip,
  petsBirthDate: petsBirthDate,
  policyStartDate: policyStartDate,
  annualLimit: annualLimit,
  benefitPercentage: benefitPercentage,
  annualExcess: annualExcess,
  suburbAndPostcode: suburbAndPostcode,
  desexing: desexing,
  optionalExtras: optionalExtras,
  vetConsultationFees: vetConsultationFees,
  misrepresentation: misrepresentation,
  noSubLimits: noSubLimits,
  paymentFrequencyTip,
  step1MultiPetDiscountTip,
  specifiedConditionsTip
};
